







import { defineAsyncComponent, defineComponent, ref, useRoute, watchEffect } from '@nuxtjs/composition-api';

export default defineComponent({
  components: {
    ActivePage: defineAsyncComponent(() => import('./index.vue')),
    ArchivePage: defineAsyncComponent(() => import('./archive.vue')),
  },
  setup () {
    const archiveMode = ref(false);
    const route = useRoute();
    watchEffect(() => {
      archiveMode.value = route.value.query.arkiv !== undefined;
    });

    return {
      archiveMode,
    };
  },
});
